import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category/category.service';
import { ProductService } from "../services/product/product.service";
@Component({
  selector: 'app-series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.css']
})
export class SeriesComponent implements OnInit {

  fornisseurs
  constructor(private categoryService:CategoryService,private productService:ProductService) { }

  ngOnInit(): void {
    this.categoryService.allCategories().subscribe(res =>{
       this.fornisseurs = res['fournisseurs']
    })
  }

}
